import { route } from '../helpers';

import { Widgets } from '../../constants/AppConstants';

export default route(Widgets.REFUND_WIDGET, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/widget/refundWidget/RefundWidget').default);
        }, 'refund-widget');
    }
});
